import React, { useState } from "react";
import "./AddEmployee.css";

const AddEmployee = () => {
  const [employeeData, setEmployeeData] = useState({
    email: "",
    name: "",
    phone: "",
    secondaryPhone: "",
    emergencyNumber: "",
    gender: "",
    joiningDate: "",
    dob: "",
    bloodGroup: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData({ ...employeeData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Employee Data:", employeeData);
    alert("Employee added successfully!");
  };

  return (
    <div className="add-employee-modal">
      <div className="modal-content">
        <h2>Create Employee</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={employeeData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={employeeData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                value={employeeData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Secondary Number</label>
              <input
                type="text"
                name="secondaryPhone"
                value={employeeData.secondaryPhone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Emergency Number</label>
              <input
                type="text"
                name="emergencyNumber"
                value={employeeData.emergencyNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Gender</label>
              <select
                name="gender"
                value={employeeData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>Joining Date</label>
              <input
                type="date"
                name="joiningDate"
                value={employeeData.joiningDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={employeeData.dob}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Blood Group</label>
              <select
                name="bloodGroup"
                value={employeeData.bloodGroup}
                onChange={handleChange}
                required
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </select>
            </div>
            <div className="form-group">
              <label>Address</label>
              <textarea
                name="address"
                value={employeeData.address}
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn-primary">
              Save
            </button>
            <button type="button" className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployee;
